/* eslint-disable react/no-danger */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import useScrollToTop from '../../hooks/useScrollToTop';
import * as AppPropTypes from '../../lib/PropTypes';

import { useEdition } from '../../contexts/EditionContext';
import { useUrlFromHandle } from '../../contexts/RoutesContext';
import Blocks from '../blocks/Blocks';
import RoundedButton from '../buttons/Rounded';
import ArrowIcon from '../icons/Arrow';
import Body from '../partials/Body';
import ListHeader from '../partials/ListHeader';
import PageTitle from '../partials/PageTitle';
import TicketPrice from '../partials/TicketPrice';

import styles from '../../../styles/pages/tickets.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const TicketsPage = ({ page, className }) => {
    const {
        tickets: pageTickets = [],
        online: hasOnline = false,
        onlineTitle = null,
        onlineDescription = null,
        screeningTitle = null,
        screeningDescription = null,
        blocks = null,
    } = page;
    const { upcoming = false } = useEdition();
    const routeByHandle = useUrlFromHandle();
    const filmsURL = routeByHandle('films');

    useScrollToTop(page);
    const allTickets = [
        {
            title: screeningTitle,
            description: screeningDescription,
            tickets: pageTickets.filter((it) => !it.online),
            online: false,
        },
        hasOnline
            ? {
                  title: onlineTitle,
                  description: onlineDescription,
                  tickets: pageTickets.filter((it) => it.online),
                  online: true,
              }
            : null,
    ].filter((it) => it !== null);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.hasOnline]: hasOnline,
                    [className]: className !== null,
                },
            ])}
        >
            <PageTitle
                title={<FormattedMessage defaultMessage="Buy tickets" description="Page heading" />}
            />

            <div className={styles.inner}>
                {allTickets.map(
                    (
                        { title = null, description = null, tickets: sectionTickets = [], online },
                        i,
                    ) => (
                        <div className={styles.section} key={`tickets-list-${i + 1}`}>
                            {title !== null ? (
                                <ListHeader className={styles.heading} title={title} />
                            ) : null}
                            {description !== null ? (
                                <Body className={styles.description} body={description} />
                            ) : null}

                            {!upcoming ? (
                                <RoundedButton
                                    href={`${filmsURL}?online=${online ? 1 : 0}`}
                                    icon={<ArrowIcon />}
                                    iconPosition="right"
                                >
                                    <FormattedMessage
                                        defaultMessage="Select a film"
                                        description="Button label"
                                    />
                                </RoundedButton>
                            ) : null}

                            {sectionTickets.map((item, index) => {
                                const {
                                    title: sectionTitle = null,
                                    prices = null,
                                    description: sectionDescription = null,
                                } = item;
                                return (
                                    <div
                                        key={`t-${index + 1}-${title}`}
                                        className={styles.ticketsSection}
                                    >
                                        {sectionTitle !== null ? (
                                            <h3 className={styles.heading}>{sectionTitle}</h3>
                                        ) : null}
                                        {sectionDescription !== null ? (
                                            <Body
                                                className={styles.description}
                                                body={sectionDescription}
                                            />
                                        ) : null}

                                        {prices !== null ? (
                                            <ul className={styles.ticketsPrices}>
                                                {prices.map(
                                                    (
                                                        {
                                                            label = null,
                                                            description: priceDescription = null,
                                                            url = null,
                                                            price = null,
                                                        },
                                                        priceIndex,
                                                    ) => (
                                                        <li key={`p-${priceIndex + 1}-${label}`}>
                                                            <TicketPrice
                                                                label={label}
                                                                description={priceDescription}
                                                                url={url}
                                                                price={price}
                                                            />
                                                        </li>
                                                    ),
                                                )}
                                            </ul>
                                        ) : null}
                                    </div>
                                );
                            })}
                        </div>
                    ),
                )}

                {/*
                <div className={styles.ticketsSection}>
                    <ListHeader className={styles.heading} title="Forfaits spéciaux" />

                    <ul className={styles.ticketsPrices}>
                        {tickets.map((ticket) => {
                            const { type = null, id, name = null, url = null, price = null } = ticket;
                            return (
                                <li key={id}>
                                    <TicketPrice
                                        label={name}
                                        url={url}
                                        price={price}
                                    />
                                </li>
                            );
                        })}
                    </ul>
                </div> */}
            </div>

            {(blocks || []).length > 0 ? (
                <div className={styles.blocks}>
                    <Blocks blocks={blocks} className={styles.blocks} isContainer />
                </div>
            ) : null}
        </div>
    );
};
TicketsPage.propTypes = propTypes;
TicketsPage.defaultProps = defaultProps;

export default TicketsPage;
